import * as React from 'react';
import { connect } from 'react-redux';
import Modal from 'react-modal';

import EventTracking from 'lib/EventTracking';
import Glyph from 'components/Glyph';
import LoadingIndicator from 'components/LoadingIndicator';
import MediaObject from 'components/MediaObject';
import Text from 'components/Text';
import { Recipient } from 'types/typescript/messagingTypes';

import SplitComposerModal from './SplitComposerModal';
import { MessageType } from './SplitComposer';
import Token from './ComposeMessageRecipientToken';

type Props = {
  onClick: () => void;
  messageType: MessageType;
  // redux
  selection: Recipient[];
  results: Array<Recipient[]>;
  // data loader
  groupsLoading?: boolean;
  orgsLoading?: boolean;
};

function ComposeMessageRecipientsInput(props: Props) {
  const [isOpen, setIsOpen] = React.useState(false);
  const { selection, messageType, groupsLoading, orgsLoading, onClick = () => {} } = props;
  return (
    <>
      <Modal isOpen={isOpen}>
        <SplitComposerModal
          onComposerPage
          messageType={messageType}
          onRequestHide={() => setIsOpen(false)}
        />
      </Modal>
      <div
        className="ComposeMessageRecipientsInput"
        onClick={() => {
          EventTracking.trackKey('announcements.share_to.input.click');
          setIsOpen(true);
          onClick();
        }}
        data-test-selector="split-composer-recipients-input"
      >
        <MediaObject
          center
          figure="right"
          gutter="xsmall"
          className="ComposeMessageRecipientsInput-inner"
        >
          <MediaObject center gutter="xsmall">
            <Text size="xsmall" color="graphite">
              To:
            </Text>
            <MediaObject center gutter="xsmall">
              <React.Fragment>
                {groupsLoading || orgsLoading ? (
                  <LoadingIndicator size="small" />
                ) : selection.length ? (
                  selection.map((s) => <Token recipient={s} key={s.id} />)
                ) : (
                  <Text color="graphite" size="xsmall">
                    Click to select recipients
                  </Text>
                )}
              </React.Fragment>
              <div /* this needs to be here or the component breaks */ />
            </MediaObject>
          </MediaObject>
          <Glyph
            className="ComposeMessageRecipientsInput-pencilIcon"
            name="pencil-stroke"
            color="graphite"
          />
        </MediaObject>
      </div>
    </>
  );
}

const mapStateToProps = ({ roleBasedMessagingSearch: { selection, results } }: any) => {
  return { selection, results };
};

export { ComposeMessageRecipientsInput };

export default connect(mapStateToProps)(ComposeMessageRecipientsInput);
